import { Link } from "react-router";
import PhotoWrapper from "./photo-wrapper";
import PropTypes from "prop-types";
import React from "react";
import ReadMore from "../../shared/read-more/";
import "./teaser.scss";
const getBiography = (bio) => {
  if (!bio) return "";
  const word = bio.split(" ");
  const count = word.slice(0, 130).toLocaleString().length;
  return bio.slice(0, count);
};

const Teaser = ({ entity }) => {
  const meetMe = (
    <div>
      <h2 className="entity-name">Meet {entity.displayName}</h2>
      <div className="header-standard fancy">
        <div>{entity.title}</div>
        <div>{entity.license}</div>
      </div>
    </div>
  );

  const biography = getBiography(entity.biography);
  return (
    <div className="container web-container" id="agent-teaser">
      <div className="teaser-wrapper row">
        <div className="hidden visible-xxs">{meetMe}</div>
        <PhotoWrapper entity={entity} customClasses="agent-photo" />
        <div
          className={
            entity.hasPhoto
              ? "col-sm-8 col-xs-16 has-photo"
              : "col-xs-16 has-no-photo"
          }
        >
          <div className="until-xs">{meetMe}</div>
          <ReadMore>
            <p
              className="text-block"
              dangerouslySetInnerHTML={{ __html: biography }}
            ></p>
          </ReadMore>
          <div className="learn-more">
            <Link to="/about" className="aw-button">
              Learn More
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

Teaser.propTypes = {
  entity: PropTypes.object.isRequired,
};

export default Teaser;



// WEBPACK FOOTER //
// ./src/components/homepage/agent/teaser.js